import React from 'react';
import { Badge, BadgeProps } from '@mantine/core';
import { TherapyStatus } from 'api/therapy';
import { UserView } from 'api/user';

interface TherapyBadgeProps extends BadgeProps {
  therapies?: UserView['therapies'];
}

const TherapyBadge = ({ therapies, ...props }: TherapyBadgeProps) => {
  const isActive = therapies?.some((t) => t.status === TherapyStatus.ACTIVE);
  if (!isActive) return null;
  return (
    <Badge color="teal" {...props}>
      therapy
    </Badge>
  );
};

export default TherapyBadge;
